import { Component, ViewChild, Renderer2, ElementRef, OnInit, AfterViewInit } from '@angular/core';
import { SettingsApiService } from 'src/app/services/settings.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgForm, NgModel } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { DirtyFormGuard, MarkCleanFormAction, MarkDirtyFormAction } from 'dirty-check-store';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { PolicySettings } from 'app-models';
import { EmailNotifyService } from 'src/app/services/email-notification.service'
import { ImagilityBaseResponse } from 'app-models';
import { HttpResponse } from '@angular/common/http';
import { ReferenceLibraryService } from 'reference-library';

@Component({
  selector: 'app-your-profile-view-to-others',
  templateUrl: './your-profile-view-to-others.component.html',
  styleUrls: ['./your-profile-view-to-others.component.scss']
})
export class YourProfileViewToOthersComponent implements OnInit, AfterViewInit {
  @ViewChild('searchControlBlock', { static: true, read: ElementRef }) searchControlBlock: ElementRef;
  @ViewChild('profileEditBlock', { static: true, read: ElementRef }) profileEditBlock: ElementRef;

  @ViewChild('notifyListForm', { static: true }) notifyListForm: NgForm;

  searchcontrol_block_change: boolean;
  profileEdit_block_change: boolean;
  notifySettings: PolicySettings;
  userTypeRole: string;
  beneficiaryId: number;
  companyId: number;
  userId: number;
  isEmailOn: boolean;
  isInAppOn: boolean;
  isAdmin: boolean;

  companyPermitEditList: { companyName: string, companyId: number, isEditable: number }[];
  companyPermitEditListModified: { companyId: number, isEditable: number }[];
  loggedInBeneficiaryId;
  searchAllow: boolean;
  searchLimited;//not implimented yet
  CompanyPermitEditCheckBox: NgModel[];

  observableSubscription$ = new Subject();
  destroy$ = new Subject<void>();
  formChangesSubscription: any;

  constructor(private settingsApiService: SettingsApiService,
    private authenticationService: AuthenticationService,
     private referenceLibraryService: ReferenceLibraryService,
    private renderer: Renderer2,
    private toastr: ToastrService,
    private router: Router,
    private guard: DirtyFormGuard,
    private store: Store<any>,
    private privacyListSettings: EmailNotifyService) {

    this.searchcontrol_block_change = true;
    this.profileEdit_block_change = true;
    this.searchAllow = false;
    this.companyPermitEditList = [];
    this.CompanyPermitEditCheckBox = [];
    this.companyPermitEditListModified = [];
    this.userTypeRole = "";
    this.isEmailOn = false;
    this.isInAppOn = false;
    this.notifySettings = {
      userId: 0,
      userType: "",
      emailSettingsDto: {
        isAttorneyAdminOn: true,
        isEmailSettingEnabled: true,
        isPetitionerAdminOn: true,
        isPlatformAdminOn: true,
        userSettingsId: 0
      },
      inAppSettingsDto: {
        isAttorneyAdminOn: true,
        isInAppSettingEnabled: true,
        isPetitionerAdminOn: true,
        isPlatformAdminOn: true,
        userSettingsId: 0
      }
    }
  }

  ngOnInit() {
    this.authenticationService.currentUser.subscribe((data) => {
      if (data) {
        data['permissions'].forEach(el => {
          if (el === 'ISADMIN') {
            this.isAdmin = true;
          }
        });
      }
    })
    this.userTypeRole = sessionStorage.getItem('userTypeRole');
    this.beneficiaryId = this.authenticationService.currentUserValue['beneficiaryId'];
    this.companyId = this.authenticationService.currentUserValue['companyId'];
    this.userId = this.authenticationService.currentUserValue['userId'];
    this.loggedInBeneficiaryId = parseInt(sessionStorage.getItem('loggedInBeneficiaryId'));
    if (this.loggedInBeneficiaryId > 0) {
      this.getSearchVisibility();
      this.getProfileEditPermission();
    }
    this.getNotifySettings();
  }



  getNotifySettings() {
    switch (this.userTypeRole) {
      case 'Beneficiary': {
        this.privacyListSettings.getPrivacySettings().subscribe((response: ImagilityBaseResponse) => {
          if (response) {
            this.notifySettings = response.data;
            console.log(this.notifySettings);
          }
          if (this.companyId !== null) {
            if ((this.notifySettings.emailSettingsDto.isPlatformAdminOn === false) ||
              (this.notifySettings.emailSettingsDto.isPetitionerAdminOn === false)) {
              this.isEmailOn = true;

            } else {
              this.isEmailOn = false;
            }
            if ((this.notifySettings.inAppSettingsDto.isPlatformAdminOn === false) ||
              (this.notifySettings.inAppSettingsDto.isPetitionerAdminOn === false)) {
              this.isInAppOn = true;

            } else {
              this.isInAppOn = false;
            }
          }
          else {
            if (this.notifySettings.emailSettingsDto.isPlatformAdminOn === false) {
              this.isEmailOn = true;

            } else {
              this.isEmailOn = false;
            }
            if (this.notifySettings.inAppSettingsDto.isPlatformAdminOn === false) {
              this.isInAppOn = true;

            } else {
              this.isInAppOn = false;
            }
          }
        })
        break;
      }
      case 'Petitioner': {
        this.privacyListSettings.getPrivacySettings().subscribe((response: ImagilityBaseResponse) => {
          if (response) {
            this.notifySettings = response.data;
          }
          if (this.isAdmin === true) {
            if (this.notifySettings.emailSettingsDto.isPlatformAdminOn === false) {
              this.isEmailOn = true;

            } else {
              this.isEmailOn = false;
            }
            if (this.notifySettings.inAppSettingsDto.isPlatformAdminOn === false) {
              this.isInAppOn = true;

            } else {
              this.isInAppOn = false;
            }
          }
          else {
            if ((this.notifySettings.emailSettingsDto.isPlatformAdminOn === false) ||
              (this.notifySettings.emailSettingsDto.isPetitionerAdminOn === false)) {
              this.isEmailOn = true;

            } else {
              this.isEmailOn = false;
            }
            if ((this.notifySettings.inAppSettingsDto.isPlatformAdminOn === false) ||
              (this.notifySettings.inAppSettingsDto.isPetitionerAdminOn === false)) {
              this.isInAppOn = true;

            } else {
              this.isInAppOn = false;
            }
          }
        })
        break;
      }
      case 'Attorney': {
        this.privacyListSettings.getPrivacySettings().subscribe((response: ImagilityBaseResponse) => {
          if (response) {
            this.notifySettings = response.data;
          }
          if (this.isAdmin === true) {
            if (this.notifySettings.emailSettingsDto.isPlatformAdminOn === false) {
              this.isEmailOn = true;

            } else {
              this.isEmailOn = false;
            }
            if (this.notifySettings.inAppSettingsDto.isPlatformAdminOn === false) {
              this.isInAppOn = true;

            } else {
              this.isInAppOn = false;
            }
          }
          else {
            if ((this.notifySettings.emailSettingsDto.isPlatformAdminOn === false) ||
              (this.notifySettings.emailSettingsDto.isAttorneyAdminOn === false)) {
              this.isEmailOn = true;

            } else {
              this.isEmailOn = false;
            }
            if ((this.notifySettings.inAppSettingsDto.isPlatformAdminOn === false) ||
              (this.notifySettings.inAppSettingsDto.isAttorneyAdminOn === false)) {
              this.isInAppOn = true;

            } else {
              this.isInAppOn = false;
            }
          }


        })
        break;
      }
    }
  }

  ngAfterViewInit() {
    this.translet();
    this.renderer.listen(this.searchControlBlock.nativeElement, 'click', () => {
      this.searchcontrol_block_change = !this.searchcontrol_block_change;
    });
    this.renderer.listen(this.profileEditBlock.nativeElement, 'click', () => {
      this.profileEdit_block_change = !this.profileEdit_block_change;
    });

    this.formChangesSubscription = this.notifyListForm.form.valueChanges
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(() => {
        if (this.notifyListForm.dirty) {
          this.store.dispatch(new MarkDirtyFormAction({
            dirty: true
          }));
        } else {
          this.store.dispatch(new MarkCleanFormAction({
            dirty: false
          }));
        }
      });
  }

  translet() {
    setTimeout(() => {
      this.referenceLibraryService.transletConversion();
    }, 600);
  }


  postNotifyList() {
    switch (this.userTypeRole) {
      case 'Beneficiary':
        const payload1 = {
          userId: this.userId,
          userType: this.userTypeRole,
          emailSettingsDto: {
            isEmailSettingEnabled: this.notifySettings.emailSettingsDto.isEmailSettingEnabled,
            userSettingsId: 0
          },
          inAppSettingsDto: {
            isInAppSettingEnabled: this.notifySettings.inAppSettingsDto.isInAppSettingEnabled,
            userSettingsId: 0
          }
        }
        this.privacyListSettings.postPrivacySettings(payload1).subscribe((response) => {
          if (response) {
            console.log("Beneficairy", payload1);
            this.toastr.success(response.message, 'Success');
          }
        })
        break;
      case 'Petitioner':
        const payload2 = {
          userId: this.userId,
          userType: this.userTypeRole,
          emailSettingsDto: {
            isEmailSettingEnabled: this.notifySettings.emailSettingsDto.isEmailSettingEnabled,
            userSettingsId: 0
          },
          inAppSettingsDto: {
            isInAppSettingEnabled: this.notifySettings.inAppSettingsDto.isInAppSettingEnabled,
            userSettingsId: 0
          }
        }
        this.privacyListSettings.postPrivacySettings(payload2).subscribe((response: ImagilityBaseResponse) => {
          if (response) {
            console.log("Petitioner", payload2);
            this.toastr.success(response.message, 'Success');
            this.store.dispatch(new MarkCleanFormAction({
              dirty: false
            }));
          }
        })
        break;
      case 'Attorney':
        const payload3 = {
          userId: this.userId,
          userType: this.userTypeRole,
          emailSettingsDto: {
            isEmailSettingEnabled: this.notifySettings.emailSettingsDto.isEmailSettingEnabled,
            userSettingsId: 0
          },
          inAppSettingsDto: {
            isInAppSettingEnabled: this.notifySettings.inAppSettingsDto.isInAppSettingEnabled,
            userSettingsId: 0
          }
        }
        this.privacyListSettings.postPrivacySettings(payload3).subscribe((response: ImagilityBaseResponse) => {
          if (response) {
            console.log("Attorney", payload3);
            this.toastr.success(response.message, 'Success');
          }
        })
        break;
    }
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
  }

  getSearchVisibility() {
    this.settingsApiService.getSearchVisibility(this.loggedInBeneficiaryId).subscribe((reponse) => {
      if (reponse['isVisible']) {
        this.searchAllow = true;
      }
      else {
        this.searchAllow = false;
      }
    })
  }

  setSearchVisibility() {
    let flag = this.searchAllow ? 1 : 0;
    let payload = {
      isVisible: flag
    }
    this.settingsApiService.setSearchVisibility(this.loggedInBeneficiaryId, payload).subscribe((reponse) => {
      if (reponse.status === 200) {
        this.toastr.success(reponse.message, 'Success');
      }
    })
  }

  getProfileEditPermission() {
    this.settingsApiService.getProfileEditPermission(this.loggedInBeneficiaryId).subscribe((reponse: []) => {
      this.companyPermitEditList = reponse;
    })
  }

  setProfileEditConfig(companyId, CompanyPermitEditCheckBox, value) {
    this.companyPermitEditListModified.forEach((item, index, array) => {
      if (item['companyId'] === companyId) {
        this.companyPermitEditListModified[index].isEditable = value;
      }
    });
    let index = this.companyPermitEditListModified.map(e => e.companyId).indexOf(companyId);
    if (index == -1) {
      this.companyPermitEditListModified.push({ companyId: companyId, isEditable: value });
    }
  }

  saveProfileEditPermission() {
    let payload = [];
    this.companyPermitEditListModified.forEach((item, index, array) => {
      payload.push({
        companyId: item['companyId'],
        isEditable: item['isEditable']
      });
    });
    this.settingsApiService.setProfileEditPermission(this.loggedInBeneficiaryId, payload).subscribe((reponse) => {
      if (reponse.status === 200) {
        this.toastr.success(reponse.message, 'Success');
      }
    })
  }

}
